module.exports = __webpack_public_path__ + "img/logo.3a17a025.svg";